module.exports = __webpack_public_path__ + "static/media/floral-design-of-retro-style-svgrepo-com.ac32931e.svg";